import type { CatalogsResponse } from "@/services/catalogService";
import { useCallback, useEffect, useMemo, useState } from "react";

const formats = [
    { value: "1_1", label: "1:1" },
    { value: "16_9", label: "16:9" },
    { value: "9_16", label: "9:16" }
];

const defaultFields = [
    {
        label: "Nombre *",
        id: "name",
        type: "text",
        placeholder: "Ingrese el nombre",
        readOnly: true
    },
    {
        label: "Marca *",
        id: "brand",
        type: "dropdown",
        placeholder: "Selecciona la marca",
        options: [],
    },
    {
        label: "Formato *",
        id: "format",
        type: "dropdown",
        placeholder: "Selecciona el formato",
        options: formats,
    },
    {
        label: "Tipo *",
        id: "type",
        type: "dropdown",
        placeholder: "Selecciona el tipo",
        options: [],
    }
]

interface UseTemplateFormFieldsProps {
    catalogs?: CatalogsResponse | null;
}

export const useTemplateFormFields = (props?: UseTemplateFormFieldsProps | undefined) => {
    const [localCatalogs, setLocalCatalogs] = useState<CatalogsResponse | null>(null);

    const brands = useMemo(() => localCatalogs?.brands.
        map((brand) => ({ value: brand.name, label: brand.name })) || [], [localCatalogs]);
    const typologies = useMemo(() => localCatalogs?.typologies.
        map((typology) => ({ value: typology.name, label: typology.name })) || [], [localCatalogs?.typologies]);

    const fields = useMemo(() => {
        return defaultFields.map((field) => {
            if (field.type === "dropdown") {
                switch (field.id) {
                    case "brand":
                        return { ...field, options: brands };
                    case "type":
                        return { ...field, options: typologies };
                    default:
                        return field;
                }
            }
            return field;
        });
    }, [brands, typologies]);

    const setCatalogs = useCallback((catalogs: CatalogsResponse) => {
        setLocalCatalogs(catalogs);
    }, []);

    useEffect(() => {
        setLocalCatalogs(props?.catalogs || null);
    }, [props?.catalogs]);

    return {
        fields,
        setCatalogs,
    };
};